import {
  FilterSequence,
  FilterSequenceFilterType,
  MatrixFilter,
  MatrixFilters,
  OptionFilters,
  TextFilters
} from "@coxauto-ui/cxm/interfaces";

const getSelectedFilterCategories = ({
  filterSequence,
  textFilters,
  optionFilters,
  matrixFilters
}: {
  filterSequence: FilterSequence[];
  textFilters: TextFilters;
  optionFilters: OptionFilters;
  matrixFilters?: MatrixFilters;
}) => {
  const selectedCategories: string[] = [];
  filterSequence.forEach(filter => {
    if (filter.filterType === FilterSequenceFilterType.textFilter) {
      if (textFilters[filter.categoryType]?.textInputValue.length > 0) {
        selectedCategories.push(filter.categoryType);
      }
    } else if (filter.filterType === FilterSequenceFilterType.optionFilter) {
      if (optionFilters[filter.categoryType]?.selectedValues.length > 0) {
        selectedCategories.push(filter.categoryType);
      }
    } else if (filter.filterType === FilterSequenceFilterType.matrixFilter) {
      if (matrixFilters) {
        const selectedMatrixValues = matrixFilters[
          filter.categoryType
        ]?.options.flatMap(option => {
          if (option.selectedValues.length > 0) {
            return [option.category];
          }
          return [];
        });
        selectedCategories.push(...selectedMatrixValues);
      }
    }
  });

  return selectedCategories.join(", ");
};

export interface FilterState {
  hasAcceptedOffersFilter: boolean;
  hasDateFilter: boolean;
  hasDealerFilter: boolean;
  hasDealPaymentMethodFilter: boolean;
  hasDealStagesFilter: boolean;
  hasDealStatusFilter: boolean;
  hasEmployeeFilter: boolean;
  hasMakeFilter: boolean;
  hasVehicleTypeFilter: boolean;
}

/**
 * Utility function to determine which filters are currently applied
 * @param optionFilters - The option filters from the store
 * @param textFilters - The text filters from the store
 * @param matrixFilters - The matrix filters from the store
 * @returns FilterState object with boolean flags for each filter type
 */
export const getFilterState = ({
  optionFilters,
  matrixFilters,
  textFilters
}: {
  optionFilters: OptionFilters;
  matrixFilters?: MatrixFilters;
  textFilters?: TextFilters;
}): FilterState => {
  const checkOptionFilter = (categoryType: string): boolean => {
    return optionFilters[categoryType]?.selectedValues?.length > 0 || false;
  };

  const checkMatrixFilter = (filterKey: string): boolean => {
    return (
      matrixFilters?.[filterKey]?.options?.some(
        (option: MatrixFilter) =>
          option.selectedValues && option.selectedValues.length > 0
      ) || false
    );
  };

  return {
    hasAcceptedOffersFilter: checkOptionFilter("isAccepted"),
    hasDateFilter: checkOptionFilter("dealActivityDate"),
    hasDealerFilter: checkOptionFilter("dealershipId"),
    hasDealPaymentMethodFilter: checkOptionFilter("dealFinanceType"),
    hasDealStagesFilter: checkMatrixFilter("dealLifecycleStage"),
    hasDealStatusFilter: checkOptionFilter("dealLifecycleStatus"),
    hasEmployeeFilter: checkOptionFilter("userId"),
    hasMakeFilter: checkOptionFilter("vehicleMake"),
    hasVehicleTypeFilter: checkOptionFilter("vehicleType")
  };
};

export default getSelectedFilterCategories;
